import type { GoldMinePlanBreakdown } from '../domain/models/GoldMinePlanBreakdown';

export function gmsRecommendedAmount(discountedPrice: number): number {
  const installment = Math.ceil(discountedPrice / 1100) * 100;
  return installment > 1000 ? installment : 1000;
}

export function gmsTotalDiscountInPercentage(
  installmentAmount: number,
  totalPayableGMSAmount: number
): string {
  return (((installmentAmount * 11) - totalPayableGMSAmount) / (installmentAmount * 11) * 100).toFixed(2);
}

export function calculateGmsPlanBreakdown(
  discountedPrice: number,
  gmsFirstInstallmentDiscountEnabled: boolean,
  gmsFirstInstallmentDiscountPercentage: number
): GoldMinePlanBreakdown {
  const installment = Math.ceil(discountedPrice / 1100) * 100;
  const installmentNew = installment > 1000 ? installment : 1000;

  let firstInstDiscount = 0;
  if (gmsFirstInstallmentDiscountEnabled && gmsFirstInstallmentDiscountPercentage > 0) {
    firstInstDiscount = Math.ceil(
      (installmentNew * gmsFirstInstallmentDiscountPercentage) / 100
    );
  }

  const totalInstallmentAmount = Math.ceil(installmentNew * 10);
  const totalPayableGMSAmount = Math.ceil(totalInstallmentAmount - firstInstDiscount);
  const totalDiscountPercentage = gmsTotalDiscountInPercentage(
    installmentNew,
    totalPayableGMSAmount
  );

  return {
    productValue: discountedPrice,
    installment: installmentNew,
    firstInstDiscount,
    totalInstallmentAmount,
    totalPayableGMSAmount,
    totalDiscountPercentage,
  };
}
